import ShoppableRoomPhoto from '@components/shoppable-home/ShoppableRoomPhoto';
import Box from '@mui/material/Box';
import { RoomShoppable } from '@pages/shop/homes/[home]/home';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import React from 'react';

import ShoppableRoomProducts from './ShoppableRoomProducts';

type ShoppableRoomProps = {
  pseudoRoom: RoomShoppable;
}

const ShoppableRoom: React.FC<ShoppableRoomProps> = (props) => {
  const { pseudoRoom } = props;
  const { md } = useBreakpoints();

  if (!pseudoRoom?.roomDocID) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      marginBottom={md ? 10 : 0}
    >
      <ShoppableRoomPhoto
        pseudoRoom={pseudoRoom}
      />
      <ShoppableRoomProducts
        pseudoRoom={pseudoRoom}
      />
    </Box>
  );
};

export default React.memo(ShoppableRoom);
